module.exports = "/fonts/NunitoSans-Bold.d8f95c6dd9af0bb1d01d942f56cd4887.ttf";